// extracted by mini-css-extract-plugin
export const headerTop = "Header-module--headerTop--1AgqI";
export const headerSiteTitle = "Header-module--headerSiteTitle--32U3k";